import { FooterOptions } from "../../base-table";
import { TableData, TableDataProps } from "../../data/table-data";

export interface TableColumnProps extends TableDataProps {
  style?: any;
  calculatedCellBgColor?: (rowIndex?: number, rowData?: any) => string;
  calculatedCellFontColor?: (rowIndex?: number, rowData?: any) => string;
  onlyRowHoverVisible?: boolean;
  specialSortingFormat?: string;
  isEditableColumn?: boolean;
  isEditMode?: boolean;
  width?: number;
  hideFiltering?: boolean;
  hideSorting?: boolean;
  hideSearch?: boolean;
  defaultDataField?: string;
  footerOptions?: FooterOptions;
  footerFormatter?: string;
  footerTextAlign?: "left" | "middle" | "right";
  footerOptionLabel?: string;
  footerFontSize?: number;
  footerFontColor?: string;
  footerFontWeight?:
    | "Thin"
    | "Extra-Light"
    | "Light"
    | "Regular"
    | "Medium"
    | "Semi-Bold"
    | "Bold"
    | "Extra-Bold"
    | "Black";
  group?: string;
  isGroup?: boolean;
  excludeFromExport?: boolean;
  fixed?: "left" | "right";
  titleBgColor?: string;
  placeholder?: string;
  id?: string;
  groupBackgroundColor?: string;
  groupFontColor?: string;
  groupFontSize?: number;
  groupFontWeight?: string;
  dateSearchFormat?: string;
  elementsDirection?: "horizontal" | "vertical";
  elementsGap?: number;
}

interface TableColumnState {}

export class TableColumn extends TableData<TableColumnProps, TableColumnState> {
  constructor(props: TableColumnProps) {
    super(props);
    this.state = {};
  }
}
